module.exports = __webpack_public_path__ + "img/J9.6d35429b.webp";